import styled from 'styled-components'

const EmptyStyle = styled.div`

    --sNoResultIconSize: var(--sp20x);
    --sNoResultIconMarginTop: var(--sp30x);
    --sNoResultIconMarginBottom: var(--sp7x);
    --sNoResultTitleMarginBottom: var(--sp5x);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .no-result-icon {
        display: inline-flex;
        margin-top: var(--sNoResultIconMarginTop);
        margin-bottom: var(--sNoResultIconMarginBottom);
        font-size: var(--sNoResultIconSize);
    }

    .no-result-title {
        margin-bottom: var(--sNoResultTitleMarginBottom);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --sNoResultIconSize: var(--sp15x);
        --sNoResultIconMarginTop: var(--sp21x);
        --sNoResultIconMarginBottom: var(--sp4x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --sNoResultIconSize: var(--sp12x);
        --sNoResultIconMarginTop: var(--sp22x);
        --sNoResultIconMarginBottom: var(--sp3x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --sNoResultIconSize: var(--sp12x);
        --sNoResultIconMarginTop: var(--sp16x);
        --sNoResultIconMarginBottom: var(--sp3x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --sNoResultIconSize: var(--sp12x);
        --sNoResultIconMarginTop: var(--sp17x);
        --sNoResultIconMarginBottom: var(--sp3x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --sNoResultIconSize: var(--sp20x);
        --sNoResultIconMarginTop: var(--sp19x);
        --sNoResultIconMarginBottom: var(--sp3x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS})  and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --sNoResultIconSize: var(--sp12x);
        --sNoResultIconMarginTop: var(--sp34x);
        --sNoResultIconMarginBottom: var(--sp3x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --sNoResultIconSize: var(--sp10x);
        --sNoResultIconMarginTop: var(--sp27x);
        --sNoResultIconMarginBottom: var(--sp2-5x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
        --sNoResultIconSize: var(--sp10x);
        --sNoResultIconMarginTop: var(--sp27x);
        --sNoResultIconMarginBottom: var(--sp2-5x);
        --sNoResultTitleMarginBottom: var(--sp3x);
    }
`

export default EmptyStyle